import { IAdminTeamResultsStore } from './store';

import api, { request } from '../../../api';
import { groupBy } from '../../../contrib/utils';
import { IErrorsStore } from '../../errors/store';
import { IActionGroup, IStore } from '../../index';

export interface IAdminTeamResultsActions extends IActionGroup {
  get: (
    roundId: number,
    player?: boolean
  ) => { adminTeamResults?: IAdminTeamResultsStore; errors?: IErrorsStore };
}

const actions: IActionGroup = {
  get: async (state: IStore, element: 'event' | 'round', elementId: number, player?: boolean) => {
    // TODO: this should have its own actions/store on player
    const response = await request.get(
      api.teamRoundLeaderboardResults(player ? 'player' : 'staff', element, {
        [`${element}_id`]: elementId
      })
    );

    if (response.error) {
      return { errors: { adminTeamResults: { msg: 'Error retrieving the Event Round Details.' } } };
    }

    const groupedByFlight = groupBy(response, 'flightId');

    return {
      ...state,
      adminTeamResults: { ...state.adminTeamResults, [elementId]: groupedByFlight }
    };
  },
  getTeamResultsForEvent: async (
    state: IStore,
    element: 'event' | 'round',
    elementId: number,
    player?: boolean
  ) => {
    // TODO: this should have its own actions/store on player
    const apiEndpoint = api.teamRoundLeaderboardResults(player ? 'player' : 'staff', element, {
      event_id: elementId
    });

    const response = await request.get(apiEndpoint);

    if (response.error) {
      return { errors: { adminTeamResults: { msg: 'Error retrieving the Event Round Details.' } } };
    }

    const groupedByFlight = groupBy(response, 'flightId');

    return {
      ...state,
      adminTeamResults: { ...state.adminTeamResults, [elementId]: groupedByFlight }
    };
  }
};

export default actions;
